import React from 'react';
import { IStep } from '../../../types/Step';
import StepSeparator from '../../content/StepSeparator';

export const StepsTestId = 'steps-framework';

export type StepsProps = {
  steps: IStep[];
  currentStep?: string;
};

export type StepProps = IStep & {
  isCurrent: boolean;
};

export const Step: React.FC<StepProps> = (step: StepProps) => {
  const { name, displayText, onClick, isCurrent, isSeparator = false } = step;
  const classes = `text-sm
    ${isCurrent ? ' font-semibold checkout-panel-section-header' : ''}
    ${
      !isCurrent && onClick ? ' cursor-pointer hover:underline' : 'cursor-auto'
    }`;

  const handleOnClick = (): void => {
    if (!isCurrent) {
      onClick?.(step);
    }
  };

  return (
    <span
      className={classes}
      onClick={handleOnClick}
      onKeyDown={event => (event.key === 'Enter' ? handleOnClick() : null)}
      role="button"
      tabIndex={0}
    >
      {isSeparator ? <StepSeparator /> : displayText || name}
    </span>
  );
};

const Steps: React.FC<StepsProps> = ({ steps, currentStep }: StepsProps) => {
  const stepsList = steps.reduce((acc: StepProps[], step, index) => {
    acc.push({
      ...step,
      isCurrent: step.name === currentStep ?? steps[0].name,
    });
    if (index !== steps.length - 1) {
      acc.push({ isCurrent: false, isSeparator: true });
    }
    return acc;
  }, []);
  return (
    <div
      data-testid={StepsTestId}
      className="space-x-2 flex justify-center flex-row mb-4 mt-2"
    >
      {stepsList.map((stepToDisplay: StepProps, index: number) => {
        return (
          <Step
            key={stepToDisplay.name ?? `${stepToDisplay.displayText}-${index}`}
            name={stepToDisplay.name}
            displayText={stepToDisplay.displayText}
            onClick={stepToDisplay.onClick}
            isCurrent={stepToDisplay.isCurrent}
            isSeparator={stepToDisplay.isSeparator}
          />
        );
      })}
    </div>
  );
};

export default Steps;
